const GreenTick = ({ width, height, className, fillColor }: GreenTickProps) => (
  <svg
    className={className}
    width={width}
    height={height}
    viewBox='0 0 32 32'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <rect width='24' height='24' rx='12' fill='#1C8913' />
    <path
      d='M6 13.8696L9.35484 17L19 8'
      stroke='white'
      stroke-width='2'
      stroke-linecap='round'
      stroke-linejoin='round'
    />
  </svg>
);

export type GreenTickProps = {
  fillColor: string;
  className?: string;
  width: string | number;
  height: string | number;
};

GreenTick.defaultProps = {
  width: 32,
  height: 32,
  fillColor: '#2A3745',
};

export default GreenTick;
